import { useMutation } from '@tanstack/react-query'
import { HttpStatusCode } from 'axios'

import { clientesKeys } from '@/features/clientes/utils'
import type { TEnviarDocumentoParams } from '@/features/enviar-documentos/interfaces'
import { EnviarDocumentoLeadService } from '@/features/enviar-documentos/services/enviar-documentos-lead.service'

export const useEnviarDocumentosLead = (clienteId: string) => {
  return useMutation({
    mutationKey: clientesKeys.cliente,
    mutationFn: async ({
      arquivo,
      tipo,
      documentId,
    }: TEnviarDocumentoParams): Promise<{ sucesso: boolean; documentId: string }> => {
      const response = await new EnviarDocumentoLeadService().execute({ arquivo, tipo, clienteId: clienteId })
      return { sucesso: response.status === HttpStatusCode.Ok, documentId }
    },
  })
}
